import moment from "moment";
const momentTz = require('moment-timezone')
const lib = {};

lib.getShowHeaderCards = (state) => (payload) => {
  if (state.headerCards[payload] === undefined) {
    return true;
  } else {
    return state.headerCards[payload];
  }
};

lib.showDisabledFilter = (state) => (payload) => {
  if (state.filterDisabled[payload] === undefined) {
    return false;
  } else {
    return state.filterDisabled[payload];
  }
};

lib.getUserInfo = (state) => (payload) => state.userData[payload];

lib.hasPlantAssigned = (state) =>
  !!(state.plantData && Object.keys(state.plantData).length);

lib.getActivePlantInfo =
  (state) => (info) => {
    if (Array.isArray(info)) {
      const rule = info.reduce((previous, current) => {
        return previous[current];
      }, state.activePlant);
      return rule;
    } else {
      return state.activePlant[info];
    }
  };

lib.getActivePlantTimezone = (state, getter) => getter.getActivePlantInfo('timezone');

lib.getPlantList = (state) => {
  const plantList = [];
  Object.entries(state.plantData).forEach(([key, value]) => {
    plantList.push({
      id: key,
      name: value.plant_name,
      location: `${value.city}||${value.state}||${value.country}`,
      timezone: value.timezone,
      plantType: value.plant_type
    });
  });
  return plantList;
};

lib.getPlantId = (state, getter) => (plantName) => {
  return getter.getPlantList
    .filter((el) => {
      return el.name.toLowerCase() == plantName.toLowerCase();
    })
    .map((el) => el.id);
};

lib.getGeneralState = (state) => (payload) => {
  if (Array.isArray(payload)) {
    const rule = payload.reduce((previous, current) => {
      return previous[current];
    }, state[payload]);
    return rule;
  } else {
    return state[payload];
  }
};

lib.getRules = (state) => (payload) => {
  if (Array.isArray(payload)) {
    const rule = payload.reduce((previous, current) => {
      return previous[current] || {};
    }, state.activePlant);
    return rule;
  } else {
    return state.activePlant[payload] || null;
  }
};

lib.isRenewExceeded = (state) => (plantId) => {
  const renewDate = state.plantData && state.plantData[plantId] && state.plantData[plantId].renew_date;
  return renewDate && momentTz().tz(state.plantData[plantId].timezone).isAfter(moment(renewDate));
};

lib.isPlantExpired = (state) => (plantId) => {
  const expiryDate =
    state.plantData &&
    state.plantData[plantId] &&
    state.plantData[plantId].expiry_date;
  return expiryDate && momentTz().tz(state.plantData[plantId].timezone).isAfter(moment(expiryDate));
};

lib.isNearingRenew = (state) => (plantId) => {
  const renewDate =
    state.plantData &&
    state.plantData[plantId] &&
    state.plantData[plantId].renew_date;
  return (
    renewDate &&
    moment(renewDate).diff(momentTz().tz(state.plantData[plantId].timezone), "days") >= 0 &&
    moment(renewDate).diff(momentTz().tz(state.plantData[plantId].timezone), "days") <= 30
  );
};

lib.getExpiryDateCount = (state) => (plantId) => {
  const expiryDate = state.plantData[plantId].expiry_date;
  return expiryDate
    ? moment(expiryDate).diff(momentTz().tz(state.plantData[plantId].timezone), "days") >= 0
      ? moment(expiryDate).diff(momentTz().tz(state.plantData[plantId].timezone), "days")
      : null
    : null;
};

lib.getRenewDate = (state) => (plantId) => {
  const renewDate = state.plantData[plantId].renew_date;
  return renewDate || "";
};

lib.getTotalPlantCount = (state) => Object.keys(state.plantData).length;

lib.getAcCapacity = (state) => {
  const totalAcCapacity = Object.values(state.plantData).reduce(
    (sum, plantInfo) => {
      if (plantInfo.plant_type === 0) {
        return sum + plantInfo.ac_capacity;
      }

      return sum;
    },
    0
  );
  return totalAcCapacity.toFixed(2);
};

lib.getDcCapacity = (state) => {
  const totalDcCapacity = Object.values(state.plantData).reduce(
    (sum, plantInfo) => {
      if (plantInfo.plant_type === 0) {
        return sum + plantInfo.dc_capacity;
      }

      return sum;
    },
    0
  );

  return totalDcCapacity.toFixed(2);
};

lib.getPlantTotalPr = (state) => state.totalPlantPr;

lib.getTotalGeneration = (state) => state.totalGeneration;

lib.getSelectedPlantId = (state) => state.activePlant.plant_id;

lib.getAllPlantCoordinates = (state) => {
  return Object.values(state.plantData).map((element) => {
    return {
      plantId: element.plant_id,
      position: {
        lat: element.latitude != null ? parseFloat(element.latitude) : null,
        lng: element.longitude != null ? parseFloat(element.longitude) : null,
      },
      plantName: element.plant_name,
    };
  });
};

lib.isComponent = (state, getter) => (componentName) => {
  let isFound =
    state.activePlant.components.search(componentName);
  return !(isFound < 0);
};

lib.isV2 = (state) => (plantId, component) =>
  !!state.activePlant.rule.comp_config[component].options.v2;

lib.getBanner = (state, getter) => (component) => {
  if (!getter.getRules(["rule", "comp_config"]) || (getter.getRules(["rule", "comp_config"]) instanceof Object && Object.keys(getter.getRules(["rule", "comp_config"])).length == 0)) {
    return {}
  }
  return (
    getter.getRules(["rule", "comp_config"])[component] &&
    getter.getRules(["rule", "comp_config"])[component].options &&
    getter.getRules(["rule", "comp_config"])[component].options.banner
  );
};

lib.getReloadTimeInMin = (state) =>
  (state.userData.refreshTime / 60000).toFixed(0);

lib.getDashboardList = (state, getter) => {
  if (!getter.getRules(["rule", "access_config"]) || (getter.getRules(["rule", "access_config"]) instanceof Object && Object.keys(getter.getRules(["rule", "access_config"])).length == 0)) {
    return [];
  }

  const more = getter.getRules(["rule", "access_config"]).more;
  const devices = getter.getRules(["rule", "access_config"]).devices;
  const defaultDashboards = [
    {
      name: getter.getRules(["rule", "access_config"]).plantOverview.name,
      path: getter.getRules(["rule", "access_config"]).plantOverview.path,
    },
    {
      name: getter.getRules(["rule", "access_config"]).alert.name,
      path: getter.getRules(["rule", "access_config"]).alert.path,
    },
  ];
  return [...devices, ...more, ...defaultDashboards];
};

lib.isDashboard = (state, getter) => (path) => {
  return !!getter.getDashboardList.find((item) => item.path === path);
};

lib.isSnackBar = (state) => state.showSnackBar;

lib.getSnackBarContent = (state) => state.snackBar;

lib.isDialog = (state) => state.showDialog;

lib.getDialogContent = (state) => state.dialog;

lib.getProgressBar = (state) => state.isProgress;

lib.navIsMini = (state) => state.miniNav;

lib.getUserData = (state) => state.userData;

lib.getPlantName = (state) => (plantId) => state.plantData[plantId].plant_name;

export default lib;
